export default __webpack_public_path__ + "static/media/conexaoVarejo.09e2b57a.png";